import type React from "react";
import { useTranslation } from "react-i18next";
import { Badge, Icon } from "@nexus/ui";
import type { InsightVerdict } from "../../lib/competitor-insight";

interface KpiInsightLineProps {
  kpiLabel: string;
  verdict: InsightVerdict;
  sentence: string;
}

const VERDICT_BADGE_VARIANT = {
  strength: "status-delivered",
  gap: "status-error",
  watch: "status-in-production",
} as const satisfies Record<InsightVerdict, React.ComponentProps<typeof Badge>["variant"]>;

export function KpiInsightLine({ kpiLabel, verdict, sentence }: KpiInsightLineProps) {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-5 items-start gap-2 px-1" aria-live="polite">
      <Icon name="lightbulb" size="sm" color="muted" className="mt-0.5" />
      <span className="shrink-0 text-[13px] leading-[1.54] text-foreground">{kpiLabel}</span>
      <Badge variant={VERDICT_BADGE_VARIANT[verdict]} dot className="mt-px h-[18px]">
        {t(`dashboard.insights.verdict.${verdict}`)}
      </Badge>
      <span className="text-pretty text-[13px] leading-[1.54] text-muted-foreground">{sentence}</span>
    </div>
  );
}
